<template>
  <div class="new-oss-main">
    <el-form
      :inline="true"
      class="demo-form-inline"
      label-width="120px"
      :model="newTemplateList"
      ref="newTemplateList"
      :rules="rules"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item :label="$translate('lang.E3202103110001', { defaultText: '租户代码' })" prop="tenantCode">
            <el-select class="new-oss-main-item" v-model="newTemplateList.tenantCode" @change="setTenantName">
              <el-option v-for="item in tenantList" :key="item.tenantCode" :label="item.tenantCode" :value="item.tenantCode"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
          <el-col :span="12" v-for="item in config.newOss.colList" :key="item.babel">
          <el-form-item :label="item.label" :prop="item.formValues" >
            <el-input class="new-oss-main-item" v-model="newTemplateList[item.formValues]" :disabled="item.disabled" ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>

      </el-row>
    </el-form>
  </div>
</template>
<script>
import config from '../ossConfig.js';
export default {
    props: ['templateList', 'tenantList'],
    data() {
        return {
            config: config,
            code: '1',
            newTemplateList: this.templateList,
            rules: {
                tenantCode: [
                    { required: true, message: this.$translate('lang.E3202103110009', { defaultText: '请选择租户代码' }), trigger: 'change' }
                ],
                accessKeyId: [
                    { required: true, message: this.$translate('lang.E3202103110010', { defaultText: '请填写访问key' }), trigger: 'blur' }
                ],
                accessKeySecret: [
                    { required: true, message: this.$translate('lang.E3202103110011', { defaultText: '请填写访问秘钥' }), trigger: 'blur' }
                ],
                endpoint: [
                    { required: true, message: this.$translate('lang.E3202103110012', { defaultText: '请填写oss地址' }), trigger: 'blur' }
                ],
                authUrl: [
                    { required: true, message: this.$translate('lang.E3202103110013', { defaultText: '请填写auth地址' }), trigger: 'blur' }
                ],
                appUrl: [
                    { required: true, message: this.$translate('lang.E3202103110014', { defaultText: '请填写app地址' }), trigger: 'blur' }
                ],
                bucketName: [
                    { required: true, message: this.$translate('lang.E3202103110015', { defaultText: '请填写bucket名字' }), trigger: 'blur' }
                ]
            }
        };
    },
    methods: {
        setTenantName(value) {
            this.tenantList.map(item => {
                if (item.tenantCode === value) {
                    this.newTemplateList.tenantName = item.tenantName;
                }
            });
        }
    }
};
</script>
<style lang="less">
.new-oss-main{
  .el-form-item__label{
        padding: 0 10px 0 0;
  }
  .new-oss-main-item{
    width: 175px;
  }
}
</style>